export const GROUPS_PRICING = [316, 155]
